

































































































































































import Vue from 'vue';
// import { User } from '@/api/types';
import { getUser, putUserPassword } from '@/api/User';
import * as api from '@/api';
import { jobs } from './enum.js';
import BindPhone from '../../components/bind-phone.vue';

export default Vue.extend({
    name: 'UserInfo',
    components: {
        // eslint-disable-next-line vue/no-unused-components
        BindPhone,
    },
    data() {
        const validatePass = (rule, value, callback) => {
            console.log((this as any).modified);
            if ((this as any).modified === '') {
                callback(new Error('请输入密码'));
            } else {
                if ((this as any).modified !== '') {
                    (this.$refs.ruleForm2 as any).validateField('checkPass');
                }
                callback();
            }
        };
        const validatePass2 = (rule, value, callback) => {
            if ((this as any).confirmed === '') {
                callback(new Error('请再次输入密码'));
            } else if ((this as any).confirmed !== (this as any).modified) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        const validateNickName = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('用户名不能为空'));
            } else if (value.length > 12) {
                callback(new Error('用户名不能超过12个字符'));
            } else {
                callback();
            }
        };
        const validateCompany = (rule, value, callback) => {
            if (value === null && value === '') {
                callback();
            }
            if (value && value.length > 30) {
                callback(new Error('公司名称不超过30个字符'));
            }
            callback();
        };
        const validatePhone = (rule, value, callback) => {
            // const repPhone = /^1(3|4|5|7|8|9)[0-9]\d{8}$/; TODO: 手机号有*号，这行废了
            if (value === '') {
                callback(new Error('手机号不能为空'));
            } else if (value.length !== 11) {
                callback(new Error('手机号格式错误，请检查'));
            } else {
                callback();
            }
        };
        return {
            phoneBindVisible: false, // 绑定手机弹窗
            countrys: [] as any, // 国家列表
            provinces: [] as any, // 省一级列表
            citys: [], // 区县一级列表
            isloading: false,
            jobs, // TODO: 当前写死
            userInfo: {
                nickName: '',
                phoneNumber: '',
                profession: '',
                organization: '',
                country: '' as any,
                province: '' as any,
                city: '' as any,
            },
            rules: {
                nickName: [
                    { validator: validateNickName, trigger: 'blur' },
                ],
                phoneNumber: [
                    { validator: validatePhone, trigger: 'blur' },
                ],
                organization: [
                    { validator: validateCompany, trigger: 'change' },
                ],
            },
            rules2: {
                pass: [
                    { validator: validatePass, trigger: 'blur' },
                ],
                checkPass: [
                    { validator: validatePass2, trigger: 'blur' },
                ],
            },
            current: '', // 旧密码
            modified: '', // 新密码
            confirmed: '',
        };
    },
    methods: {
        // 关闭绑定弹窗
        async close() {
            await this.init();

            this.phoneBindVisible = false;
        },
        async provinceChange(val) {
            await this.getRegions(val.code, 'citys');
            this.userInfo.city = this.citys[0];
        },
        // 获取省份
        async getProvinces(country) {
            (this as any).provinces = await this.getPrefecture(country);
        },
        async getCitys(province) {
            (this as any).citys = await this.getPrefecture(province);
        },
        async getPrefecture(parentCode) {
            const resp = await api.getRegions({ parentCode });
            if (!api.error(resp)) {
                return resp.data;
            }
            return [];
        },
        async getRegions(parentCode, name: string) {
            const res = await api.getRegions({ parentCode });
            if (!api.error(res)) {
                this[name] = res.data;
            }
        },
        async getCity(parentCode) {
            const resp = await api.getRegions({ parentCode });
            if (!api.error(resp)) {
                console.log(8989, resp.data);
            }
        },
        async getUserInfo() {
            const userInfo = await getUser();
            if (!api.error(userInfo)) {
                return userInfo;
            }
            return {};
        },
        async editUserInfo() {
            const { phoneNumber, ...option } = this.userInfo;
            console.log(phoneNumber, option);
            if (Object.prototype.toString.call(option.country) === '[object Object]') {
                option.country = option.country.name;
            }
            if (Object.prototype.toString.call(option.province) === '[object Object]') {
                option.province = option.province.name;
            }
            if (Object.prototype.toString.call(option.city) === '[object Object]') {
                option.city = option.city.name;
            }
            const res = await api.editUserInfo(option);
            if (!api.error(res)) {
                this.$message({
                    type: 'success',
                    message: '保存成功',
                    duration: 2000,
                });
                const timer = setTimeout(() => {
                this.$store.dispatch('fetchUserInfo', localStorage.getItem('token'));
                this.$store.dispatch('fetchUserInfoToCheckPhone', localStorage.getItem('token'));
                clearTimeout(timer);
                }, 2000);
            }
        },
        submitUserInfo(formName) {
            (this.$refs[formName] as any).validate((valid) => {
                if (valid) {
                    this.editUserInfo();
                }
                console.log('error submit!!');
                return false;
            });
        },
        async putUserPassword() {
            const res = await putUserPassword({
                current: this.current,
                modified: this.modified,
            });
            if (!api.error(res)) {
                this.$message({
                    message: '修改成功',
                    type: 'success',
                });
            } else {
                this.$message({
                    message: res.error.message,
                    type: 'error',
                });
            }
        },
        submitForm(formName) {
            (this.$refs[formName] as any).validate((valid) => {
                if (valid) {
                    this.putUserPassword();
                    return true;
                }
                console.log('error submit!!');
                return false;
            });
        },
        async init() {
            await this.getRegions('', 'countrys'); // 获取国家列表
            await this.getRegions(this.countrys[0].code, 'provinces'); // 省级列表
            const userInfo: any = await this.getUserInfo();
            let provinceCode = this.provinces[0].code;
            // 恶心
            if (userInfo.data) {
                const matchProvince = this.provinces.find((item) => item.name === userInfo.data.province);
                if (matchProvince) provinceCode = matchProvince.code;
                await this.getRegions(provinceCode, 'citys');
                this.userInfo.nickName = userInfo.data.nickName;
                this.userInfo.phoneNumber = userInfo.data.phoneNumber;
                this.userInfo.profession = userInfo.data.profession;
                this.userInfo.organization = userInfo.data.organization;
                this.userInfo.country = userInfo.data.country;
                this.userInfo.province = userInfo.data.province;
                this.userInfo.city = userInfo.data.city;
            }
        },
    },
    async created() {
        await this.init();
    },
});
